import React, {useEffect, useState} from "react";
import {Container, Button, TextField,MenuItem} from '@mui/material';
import {makeStyles} from "@mui/styles";
import Service from "../services/Service";
import {useDispatch, useSelector} from "react-redux";
import {getPortfolios,getPortfolio} from "../store/actions";
import {currencies} from "../AppConstants";
import {Box} from "@mui/system";


const service = new Service();
export default function (props) {
    const {action} = props
    const dispatch = useDispatch()
    const handleSend = () => {
            service.createPortfolio(
                {
                    "name": name,
                    "currency": currency
                }
            ).then((result) => {
                    dispatch(getPortfolios());
                action(true)

            }).catch(() => {
                alert('Ошибка при добавлении');
            });
    };

    const [currency, setCurrency] = useState('RUB');
    const [name, setName] = useState('Новый портфель');

    const handleChange = (event) => {
        setCurrency(event.target.value);
    };
    const useStyles = makeStyles({
        gridContainer: {
            paddingTop: "40px"
        },
        root: {
            minWidth: 200,
            minHeight: 150
        },
        title: {
            fontSize: 14
        },
        pos: {
            marginBottom: 12
        }
    });
    // useEffect(() => {
    //
    //     service.getPortfolios().then(function (response) {
    //             setPortfolios(response)
    //         }
    //     )
    // }, []);
    const classes = useStyles();
    return (
        <Container style={{marginTop: 30}}>

                    <TextField
                        InputLabelProps={{shrink: true}}
                        style={{ marginBottom: 10 }}
                        placeholder="20"
                        autoFocus
                        variant="outlined"
                        autoComplete='off'
                        id="name"
                        label="Название портфеля"
                        //value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="Новый портфель"
                        fullWidth
                    />
                    <TextField
                        id="currency"
                        select
                        variant="outlined"
                        label="Валюта портфеля"
                        value={currency}
                        onChange={handleChange}
                        fullWidth
                    >
                        {currencies.map((option) => (
                            <MenuItem key={option.id} value={option.value}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </TextField>

            <Box alignContent="flex-end">
                <Button size="large" sx={{ mr: 1 ,mt:2}} onClick={handleSend} fullWidth variant="outlined" color="primary" >
                    Далее
                </Button>
            </Box>
        </Container>
    );
}
